import React from 'react';
import classnames from 'clsx';

import { Checkbox } from 'ui-components/components/checkbox';
import { Text, TextType } from 'ui-components/components/text';

import styles from './style.module.less';

/**
 * Renders a checkbox for accepting terms and conditions
 * @param {object} props
 * @param {boolean} [props.isChecked] - Whether the checkbox is checked
 * @param {(updateValue: (string | number | boolean)) => void} props.handleTermsChecked - Callback function when checkbox state changes
 * @param {string} [props.className] - CSS class for the checkbox component
 * @param {string} [props.innerClassname] - CSS class for the inner checkbox element
 * @param {object} props.checkboxLabel - Internationalized message object for the checkbox label
 * @param {string} [props.containerClassName] - CSS class for the container div
 * @param {boolean} [props.disabled] - Whether the checkbox is disabled
 * @returns {React.JSX.Element} Checkbox component for terms acceptance
 */
export const AcceptTerms = ({
  isChecked = false,
  handleTermsChecked,
  className,
  innerClassname,
  checkboxLabel,
  containerClassName,
  disabled,
}) => {
  return (
    <div className={containerClassName}>
      <Checkbox
        checked={isChecked}
        className={classnames(styles['term-checkbox'], className)}
        disabled={disabled}
        innerClassname={classnames(styles['term-checkbox-inner'], innerClassname)}
        onChange={handleTermsChecked}
      >
        <Text textType={TextType.Paragraph} value={checkboxLabel} />
      </Checkbox>
    </div>
  );
};
